import { render, staticRenderFns } from "./TreeList.vue?vue&type=template&id=58c9d804&scoped=true"
import script from "./TreeList.ts?vue&type=script&lang=ts&external"
export * from "./TreeList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c9d804",
  null
  
)

export default component.exports